module.exports = __webpack_public_path__ + "tgm/img/cnt-prize.873dc3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/cnt-prize.png
// module id = bYss
// module chunks = 1